import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IMember, IThread, IThreadShort, IUser } from "../interfaces/App";
import { createThread, deleteThread, updateThread } from "../services/apiService";
import type { AppDispatch, IApplicationState } from "../stores/AppStore";

export interface IExUser extends IUser {
    adminId: number;
};

function ChatEdit() {
    const dispatch = useDispatch<AppDispatch>();
    const app = useSelector((appState: IApplicationState) => appState.app);
    const newThread: IThreadShort = {name: "<new>", threadId: 0, members: []};
    const [edtThread, setEditThread] = useState(null as IThreadShort);
    const [availMembers, setAvailMembers] = useState(null as IUser[]);

    // useEffect(() => {
    // }, []);
    useEffect(() => {
        setAvailMembers(app.users);
    }, [app.users]);
    const sortMember = (a: IMember, b: IMember) => {
        if (a.userId > b.userId) return 1;
        if (a.userId < b.userId) return -1;
        return 0;
    };
    // const handleCreateThread = () => {
    //     dispatch(createThread({threadId: 0, name:"new", members: [{userId: app.user.id, name: "", admin: true}]  })); 
    // }
    const handleThreadChanges = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        if (edtThread?.threadId === 0) {
            dispatch(createThread({...edtThread, members: [...edtThread.members, {userId: app.user.id, name: "", admin: true}]  })); 
        } else {
            const oriThread = app.threads.find((t: IThread) => t.threadId === edtThread.threadId);
            const oriMembers = [...oriThread.members]
                                .sort(sortMember)
                                .map((m: IMember) => {return String(m.userId) + ":" + (m.admin ? "1" : "0")})
                                .join(".");
            const updMembers = [...edtThread.members]
                                .sort(sortMember)
                                .map((m: IMember) => {return String(m.userId) + ":" + (m.admin ? "1" : "0")})
                                .join(".");
            const updThread = {...edtThread, members: [...edtThread.members]};
            if (edtThread.name === oriThread.name) {
                delete updThread.name;
            }
            if (oriMembers === updMembers) {
                delete updThread.members;
            }
            if (updThread.members || updThread.name) {
                dispatch(updateThread({...updThread}));
            }
        }
        setEditThread({...newThread, threadId: undefined});
    };
    const handleDeleteThread = (ev: any, threadId: number) => {
        ev.preventDefault();
        ev.stopPropagation();
        dispatch(deleteThread(threadId));
    }

    const renderUserEntries = (user: IUser) => {
        return (
            <option
                key={"user_id_" + user.id}
                value={user.id}
            >
                {user.name}
            </option>
        );
    };
    const setMemberList = (userId: string) => {
        let temp: IMember[] = [...edtThread.members];
        // const id = parseInt(userId, 10);
        if (temp.find((m: IMember) => m.userId === userId)) {
            // delete if in
            temp = temp.filter((m: IMember) => m.userId !== userId);
        } else {
            // insert if not in
            const user = availMembers.find((u: IUser) => u.id === userId);
            if (user) {
                temp.push({userId, name: user.name});
            }
        }
        setEditThread({...edtThread, members: temp});
    };

    const renderUserShortListBox = () => {
        const values = edtThread.members.map((m: IMember) => {return String(m.userId)});
        return availMembers?.length > 0 
        ? (
            <select
                multiple={true}
                size={availMembers.length}
                value={values}
                onChange={(ev: any) => setMemberList(ev.target.value)}
                onClick={(ev: any) => ev.stopPropagation()}
            >
                {availMembers.map(renderUserEntries)}
            </select>
        ) : (null);
    };
    const renderTheadInfo = (thread: IThread) => {
        const canDelete = thread.thread?.length === 0;
        return (
            <>
                <td>{thread.name}</td>
                <td>{thread.members.map((m: IMember) => m.name).join(",")}</td>
                <td>{canDelete && <button onClick={(ev: any) => handleDeleteThread(ev, thread.threadId)}>Löschen</button> }</td>
            </>
        );
    };
    const renderThreadEdit = () => {
        const members = edtThread.members;
        const threadToEdit = {threadId: edtThread.threadId, name: edtThread.name, members};
        return (
            <>
                <td>
                    <input
                        value={threadToEdit.name} 
                        onChange={(ev: any) => setEditThread({...threadToEdit, name: ev.target.value})}
                        onClick={(ev: any) => ev.stopPropagation()}
                    />
                </td>
                <td>{renderUserShortListBox()}</td>
                <td onClick={(ev: any) => ev.stopPropagation()}>
                    <input type="reset" value="Abbruch" />
                    <input type="submit" value="OK" />
                </td>
                <td/>
            </>
        );
    };
    // const renderNewThread  = () => {
    //     return (
    //         <tr><td><Button onClick={() => handleCreateThread()} label="Neu"/></td><td></td><td></td></tr>
    //     )
    // };
    const renderThreadLine = (thread: IThread) => {
        return (
            <tr 
                key={"thread_" + thread.threadId}
                onClick={() => setEditThread({threadId: thread.threadId, name: thread.name, members: thread.members})}
            >
                {edtThread?.threadId === thread.threadId ? renderThreadEdit() : renderTheadInfo(thread)}
            </tr>    
        );
    };
    return (   
        <form 
            onSubmit={(ev: any) => handleThreadChanges(ev)}
            onReset={(ev: any) => {ev.preventDefault(); setEditThread({...newThread, threadId: undefined}); }}
        >
            <table>
                <tbody>
                    <tr><th>Name</th><th>Teilnehmer</th><th/><th/></tr>
                    {/* {app.threads.length === 0 ? renderNewThread() : app.threads.map(renderThreadLine)} */}
                    {app.threads.map(renderThreadLine)}
                    {renderThreadLine(newThread as IThread)}
                </tbody>
            </table>
        </form>
    );
}
export default ChatEdit;
